// extracted by mini-css-extract-plugin
module.exports = {"bargraphLeadText":"bargraphLeadText"};